import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M17.813 12c0 3.237-2.603 5.86-5.813 5.86S6.188 15.238 6.188 12 8.79 6.14 12 6.14s5.813 2.624 5.813 5.86M.308 10.605h2.76c.17 0 .307.303.307.678v1.434c0 .375-.137.678-.308.678H.307c-.17 0-.307-.303-.307-.678v-1.434c0-.374.138-.678.308-.678M13.313.288v2.587c0 .159-.286.288-.639.288h-1.348c-.353 0-.639-.129-.639-.288V.288c0-.16.286-.288.639-.288h1.348c.353 0 .639.129.639.288M13.313 20.787v2.891c0 .178-.286.322-.639.322h-1.348c-.353 0-.639-.144-.639-.322v-2.89c0-.179.286-.323.639-.323h1.348c.353 0 .639.145.639.322M20.933 10.605h2.76c.17 0 .307.303.307.678v1.434c0 .375-.137.678-.308.678h-2.76c-.17 0-.306-.303-.306-.678l-.001-1.434c0-.374.137-.678.308-.678"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  "fill-rule": "evenodd",
  d: "M12.046 21.675c5.41 0 9.797-4.352 9.797-9.721 0-5.37-4.386-9.722-9.796-9.722-5.411 0-9.797 4.353-9.797 9.721s4.386 9.721 9.796 9.721M12 20.092c4.556 0 8.25-3.665 8.25-8.186S16.556 3.721 12 3.721s-8.25 3.665-8.25 8.186 3.694 8.186 8.25 8.186",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }